import styled from 'styled-components'

/** Preenche o espaço abaixo do header do painel + subheader, sem scroll próprio */
export const PipelinePageShell = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: visible;
  width: 100%;
`

/** Área do Outlet (kanban / ticket); scroll fica só dentro do board ou da tabela */
export const PipelineMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`

export const KanbanTableRoot = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Pipeline = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 0;
  gap: 0.75rem;
  align-items: stretch;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
`

export const StepColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex: 0 0 255px;
  min-width: 255px;
  min-height: 0;
  border-radius: 0.45rem;
  overflow: hidden;
`

export const StepHeader = styled.div`
  padding: 0.55rem 0.7rem;
  font-size: 0.8rem;
  font-weight: 700;
  color: #3a3a3a;
  line-height: 1.4;
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
`

export const TitleWithActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-left: auto;
`

export const StepCardCountBadge = styled.span`
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.35rem;
  border-radius: 9999px;
  background-color: #eef6fb;
  color: #0f3f59;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const IconButton = styled.button`
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.15rem;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.15s ease;

  &:hover {
    color: #0090d3;
  }
`

export const TicketList = styled.ul`
  background-color: transparent;
  padding: 0.35rem 0 0;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  gap: 0.35rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`

export const TicketItem = styled.li`
  background-color: #fff;
  user-select: none;
  width: 100%;
  padding: 0.55rem 0.65rem;
  border-radius: 0.45rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  box-sizing: border-box;
`

export const CardTitle = styled.h3`
  font-size: 0.78rem;
  font-weight: 600;
  color: #1f1f1f;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
`

export const HorizontalDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  width: 100%;
`

export const MetaData = styled.label<{color?: string, fontSize?: string}>`
  font-size: ${({fontSize}) => fontSize || '0.68rem'};
  font-weight: 500;
  color: ${({color}) => color || '#6b7280'};
  display: flex;
  align-items: center;
  gap: .25rem;
`

export const CardMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 2px;
`

export const CardMetaItem = styled.span<{color?: string}>`
  font-size: 10px;
  font-weight: 500;
  color: ${({color}) => color || '#9CA3AF'};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const AddInStep = styled.button`
  padding: .3rem;
  border-radius: 0.45rem;
  color: #0090d3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  cursor: pointer;
  font-size: 0.78rem;
  font-weight: 700;
  border: none;
  width: 100%;
  margin-top: 0.3rem;
  background-color: transparent;
`

export const InputForAdd = styled.input`
  width: calc(100% - 1.5rem);
  border: none;
  outline: none;
  background-color: #F4F4F4;
  height: 34px;
  padding: 0 0.75rem;
  border-radius: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #696969;
`

export const AddStep = styled.button`
  border-radius: 50%;
  background-color: #fff;
  width: 2rem;
  height: 2rem;
  border: 1.5px solid #0090D3;
  color: #0090D3;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
`